// extracted by mini-css-extract-plugin
export var btn_wrap = "style-module--btn_wrap--o8bey";
export var confirm = "style-module--confirm--3OMUi";
export var result1 = "style-module--result1--G3J-J";
export var blank = "style-module--blank--UFD5I";
export var dashboard1 = "style-module--dashboard1--r4JrP";
export var dashbord1 = "style-module--dashbord1--Alijb";
export var qa = "style-module--qa--KO7z-";
export var policy = "style-module--policy--AkfMN";
export var studless = "style-module--studless--yNw25";
export var contact = "style-module--contact--wiW-k";
export var top = "style-module--top--WcxLV";
export var begin = "style-module--begin--yI1It";
export var cancel = "style-module--cancel--R5CMg";
export var backToTop = "style-module--backToTop--6KDbf";
export var closeModal = "style-module--closeModal--v9Rn+";